import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-languageAccessService',
    templateUrl: './languageAccessService.component.html',
    styleUrls: ['./languageAccessService.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LanguageAccessServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
